import React from "react";
import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ children, index }) => (
  <div className="flex items-center gap-4">
    {index !== undefined && (
      <span className="font-mono text-[11px] text-[#e60000] tracking-widest">
        {String(index).padStart(2, "0")}
      </span>
    )}
    <span className="overline">{children}</span>
    <span className="flex-1 h-px bg-white/10" />
  </div>
);

export default Reveal;
